import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch('https://infrec.in/php-backend/backend/blog/get-blogs.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBlogs(data.blogs);
        }
      })
      .catch(err => console.error('Error fetching blogs:', err));
  }, []);

  return (
    <>
      <section className="bg-darkBlue text-white min-h-[30vh] md:min-h-[30vh] flex items-center justify-center" style={{ paddingTop: '0.5rem' }}>
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 items-center justify-center">
            <div className="col-span-12 text-center">
              <div className="py-8">
                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold mb-4 pt-12 md:pt-10">
                  Blog
                </h2>
                <p className="text-lg opacity-80">Stay updated with the latest insights on insurance and financial planning</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog) => (
              <div key={blog.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img src={blog.image_url} alt={blog.title} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-sm font-semibold text-blue-600">{blog.category}</span>
                    <span className="text-sm text-gray-500">{blog.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{blog.title}</h3>
                  <p className="text-gray-600 mb-4">{blog.excerpt}</p>
                  <Link to={`/blog/${blog.id}`} className="text-blue-600 font-semibold hover:text-blue-800 transition-colors">
                    Read More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;
